const AccountConsentRouter = [
  {
    path     : '/account/consent',
    component: () => import ('@/app/layout/view/layout-consent-default.vue'),
    redirect : '/account/consent/account-consent-agree',
    children : [
      {
        path     : 'account-consent-agree',
        meta     : {routerGuard: true},
        component: () => import('@/app/account/consent/view/account-consent-profiles-agree.vue'),
      },
    ]
  },
  {
    path     : '/account/consent/popup',
    component: () => import ('@/app/layout/view/layout-consent-popup-default.vue'),
    redirect : '/account/consent/popup/account-consent-agree-popup',
    children : [
      {
        path     : 'account-consent-agree-popup',
        meta     : {routerGuard: true},
        component: () => import('@/app/account/consent/view/account-consent-profiles-agree-popup.vue'),
      },
    ]
  },
];

export default AccountConsentRouter;
